<div class="p-4">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
    <!-- Total Funds Chart - Top Left -->
    <p-card>
      <div class="flex flex-col gap-4">
        <div class="flex justify-between items-center">
          <h3 class="text-heading-md">{{ 'platformInsights.totalFunds.title' | translate }}</h3>
          <p-select [options]="periodOptions" [formControl]="totalFundsPeriodControl" optionLabel="label"
            optionValue="value" styleClass="w-32" />
        </div>
        <div class="text-start">
          <p class="text-label-sm text-secondary mb-1">
            {{ 'platformInsights.totalFunds.raisedAmount' | translate }}
          </p>
          <p class="text-heading-xl font-bold text-primary">{{ totalFundsAmount() | currency }}</p>
        </div>
        <p-chart type="bar" [data]="totalFundsData()" [options]="totalFundsOptions" height="180px"></p-chart>
      </div>
    </p-card>

    <!-- Active Launches Chart - Top Right -->
    <p-card>
      <div class="flex flex-col gap-4">
        <h3 class="text-heading-md">{{ 'platformInsights.activeLaunches.title' | translate }}</h3>
        <div class="flex flex-col lg:flex-row items-center justify-center gap-6 py-2">
          <div class="flex-shrink-0 w-full max-w-[250px] aspect-square">
            <p-chart type="pie" [data]="activeLaunchesData()" [options]="activeLaunchesOptions"></p-chart>
          </div>
          <div class="flex flex-col gap-2 w-full lg:w-auto lg:min-w-[180px]">
            @for (status of projectStatusList(); track status.key) {
            <div class="flex items-center gap-2">
              <div class="w-3 h-3 rounded-full flex-shrink-0" [style.background-color]="status.color"></div>
              <span class="text-body-sm flex-1">{{ status.label | translate }} ({{ status.count }})</span>
            </div>
            }
          </div>
        </div>
      </div>
    </p-card>
  </div>

  <!-- Total Investors Chart and Pending Approvals - Bottom Row -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
    <!-- Total Investors Chart - Bottom Left (2/3 width) -->
    <div class="lg:col-span-2">
      <p-card>
        <div class="flex flex-col gap-4">
          <div class="flex justify-between items-center">
            <h3 class="text-heading-md">
              {{ 'platformInsights.totalInvestors.title' | translate }}
            </h3>
            <p-select [options]="periodOptions" [formControl]="totalInvestorsPeriodControl" optionLabel="label"
              optionValue="value" styleClass="w-32" />
          </div>
          <div class="text-start">
            <p class="text-label-sm text-secondary mb-1">
              {{ 'platformInsights.totalInvestors.totalCount' | translate }}
            </p>
            <p class="text-heading-xl font-bold text-primary">{{ totalInvestorsCount() }}</p>
          </div>
          <p-chart type="line" [data]="totalInvestorsData()" [options]="totalInvestorsOptions" height="225px"></p-chart>
        </div>
      </p-card>
    </div>

    <!-- Projects Waiting for Approval - Bottom Right (1/3 width) -->
    <div class="lg:col-span-1">
      <p-card>
        <div class="flex flex-col gap-4">
          <h3 class="text-heading-md">
            {{ 'platformInsights.pendingApprovals.title' | translate }}
          </h3>
          <p-table [value]="pendingProjects()" [tableStyle]="{ 'min-width': '100%' }" [stripedRows]="true"
            styleClass="p-datatable-sm">
            <ng-template pTemplate="body" let-project>
              <tr>
                <td>
                  <span class="text-body-sm">{{ project.name }}</span>
                </td>
                <td style="width: 60px">
                  <div class="flex gap-2">
                    <p-button icon="pi pi-arrow-right" [rounded]="true" size="small"
                      [ariaLabel]="'platformInsights.pendingApprovals.viewDetails' | translate"
                      (onClick)="openProjectDetails(project.id)" />
                  </div>
                </td>
              </tr>
            </ng-template>

            <!-- Empty state -->
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2" class="text-center py-8">
                  <div class="flex flex-col items-center gap-3">
                    <i class="pi pi-inbox text-4xl text-muted"></i>
                    <p class="text-body-md text-muted">
                      {{ 'platformInsights.pendingApprovals.noData' | translate }}
                    </p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-card>
    </div>
  </div>
</div>
